import Page from 'src/components/molecules/page';
import { Container } from '@mui/material';
import { FC } from 'react';

import { CustomerReservationDone } from 'src/components/organisms/customer-reservation/done';

export const CustomerReservationDonePage: FC = () => {
  /* 定数宣言 */
  const title = '予約完了';

  return (
    <Page title={title}>
      <Container maxWidth={false}>
        <CustomerReservationDone />
      </Container>
    </Page>
  );
};
